import type {ExternalServiceType} from 'nutshell-graphql-types';
import type {GetActivityForModal_activity as Activity} from 'nutshell-graphql-types';

export const hasAtLeastOneAccountOrContactOnActivity = (activity: Activity): boolean => {
    return activity.participants.some(
        (participant) => participant.type === 'accounts' || participant.type === 'contacts'
    );
};

export const hasAtLeastOneExternalAttendeeOnActivity = (activity: Activity): boolean => {
    return activity.participants.some(
        (participant) => participant.type === 'activityExternalAttendees'
    );
};

export const getExternalServiceTypeName = (serviceType?: ExternalServiceType | null): string => {
    switch (serviceType) {
        case 'ZOOM':
            return 'Zoom meeting';
        case 'GOOGLE_MEET':
            return 'Google meet meeting';
        case 'MICROSOFT_TEAMS':
            return 'Microsoft teams meeting';
        case 'CALLTRACKERFX':
            return 'CallTrackerFX call';
        case 'CALLRAIL':
            return 'CallRail call';
        case 'AIRCALL':
            return 'Aircall call';
        case 'RINGCENTRAL':
            return 'RingCentral call';
        case 'DIALPAD':
            return 'Dialpad call';
        default:
            return 'external meeting';
    }
};
